import Modal from '../../../component/modal/Modal';
import fileImage from '../../../assets/image/file.svg';
import { getDate } from '../../../utils/dateUtils';
import { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { applyInvoiceFromCreditNote } from '../../../services/sales_credit_note';

const ApplyInvoice = ({
	creditNoteDetails,
	isApplyInvoice,
	setIsApplyInvoice,
	getCreditNoteDetails,
}) => {
	const [openInvoiceTable, setOpenInvoiceTable] = useState([]);
	const [errorCells, setErrorCells] = useState([]);
	const [error, setError] = useState('');
	const [isLoading, setLoading] = useState(false);
	const inputRefs = useRef([]);
	function changeInputByEnter(index) {
		if (openInvoiceTable.length > index) {
			if (inputRefs.current[index + 1]) {
				inputRefs.current[index + 1].focus();
			}
		}
	}

	const handleCreditChange = (index, value) => {
		let openTableData = [...openInvoiceTable];
		let errors = [...errorCells];

		if (Number(value) > Number(openTableData[index].balance_due_before)) {
			const errIndex = errors.findIndex((err) => err.index === index);
			if (errIndex !== -1) {
				errors[errIndex].error = 'Invalid credit';
			} else {
				errors.push({ index, error: 'Invalid credit' });
			}
		} else {
			errors = errors.filter((err) => err.index !== index);
		}

		openTableData[index].applied_credit_amount = value;
		setOpenInvoiceTable(openTableData);
		setErrorCells(errors);
		if (
			totalRemainingCredit() >
			Number(creditNoteDetails.total_credit_amount).toFixed(2) -
				Number(creditNoteDetails.total_paid_amount).toFixed(2)
		) {
			setError('Applied credit cannot exceed available credit.');
		} else {
			setError('');
		}
	};

	const handleKeyDown = (index, event) => {
		if (event.key === 'Enter') {
			event.preventDefault();
			changeInputByEnter(index);
		}
	};
	const totalRemainingCredit = () => {
		return Number(
			openInvoiceTable?.reduce((sum, cn) => Number(sum) + Number(cn.applied_credit_amount), 0),
		);
	};

	useEffect(() => {
		if (creditNoteDetails && creditNoteDetails.invoices.length > 0) {
			getOpenInvoicetable();
		}
	}, [creditNoteDetails]);

	const getOpenInvoicetable = () => {
		var list = creditNoteDetails.invoices.map((ele) => {
			return {
				id: ele?.id,
				invoice_number: ele?.invoice_number,
				date: ele?.date,
				total_amount: ele?.total_amount,
				balance_due_before: ele?.due_amount,
				applied_credit_amount: 0,
			};
		});
		setOpenInvoiceTable(list);
	};

	const handleSaveInvoice = async () => {
		if (totalRemainingCredit() > 0) {
			try {
				setLoading(true);
				var body = {
					credit_note_id: creditNoteDetails?.id,
					invoices: openInvoiceTable.filter((data) => Number(data.applied_credit_amount) > 0),
					total_credit_applied: totalRemainingCredit().toFixed(2),
				};
				var res = await applyInvoiceFromCreditNote(body);
				if (res?.success) {
					getCreditNoteDetails();
					toast.success(res.message);
					setIsApplyInvoice(false);
				} else {
					toast.error(res?.message || error?.message || 'Failed to apply credit note');
				}
			} catch (error) {
				toast.error(error?.message);
			} finally {
				setLoading(false);
			}
		} else {
			setError('Please enter credit to apply amount');
		}
	};

	return (
		<Modal
			className={'applyInvoiceModel'}
			isOpen={isApplyInvoice}
			onClose={() => setIsApplyInvoice(false)}
			cancelButton={() => setIsApplyInvoice(false)}
			actionButton={isLoading ? null : isApplyInvoice}
			handleSave={() => {
				handleSaveInvoice();
			}}
			title={
				<div
					style={{
						fontWeight: '600',
						color: '#0F1C35',
						fontSize: '22px',
						paddingTop: '10px',
					}}
				>
					Apply Credit to Invoices
				</div>
			}
			headerClassName="discard-header"
			bodyClassName="discard-Body"
		>
			<div>
				<div
					style={{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'flex-start',
						margin: '10px 0px',
					}}
				>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'flex-start',
							marginRight: '20px',
						}}
					>
						<div
							style={{
								width: '40px',
								height: '40px',
								borderRadius: '50px',
								backgroundColor: '#ED9448',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
							}}
						>
							<img
								src={fileImage}
								style={{ width: '25px', height: '25px' }}
								alt=""
							/>
						</div>
						<div style={{ display: 'flex', flexDirection: 'column', padding: '0px 10px' }}>
							<div style={{ color: '#555B67', fontSize: '14px', fontWeight: '400' }}>
								Credit Notes
							</div>
							<div style={{ color: '#00000', fontSize: '14px', fontWeight: '700' }}>
								{creditNoteDetails.credit_note_number || ''}
							</div>
						</div>
					</div>
					<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
						<div
							style={{
								width: '40px',
								height: '40px',
								borderRadius: '50px',
								backgroundColor: '#7189AC',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
							}}
						>
							<img
								src={fileImage}
								style={{ width: '25px', height: '25px' }}
								alt=""
							/>
						</div>
						<div style={{ display: 'flex', flexDirection: 'column', padding: '0px 10px' }}>
							<div style={{ color: '#555B67', fontSize: '14px', fontWeight: '400' }}>
								Available Credit
							</div>
							<div style={{ color: '#00000', fontSize: '14px', fontWeight: '700' }}>
								{creditNoteDetails.remaining_credits ??
									creditNoteDetails.available_credit ??
									(Number(creditNoteDetails.total_credit_amount) - Number(creditNoteDetails.total_paid_amount))}
							</div>
						</div>
					</div>
				</div>
				<div style={{ padding: '20px 0px', width: '100%' }}>
					<table
						style={{
							width: '100%',
							borderCollapse: 'collapse',
							tableLayout: 'fixed',
						}}
					>
						<thead style={{ display: 'table', tableLayout: 'fixed', width: '100%' }}>
							<tr
								style={{
									backgroundColor: '#E6F5FF',
									textAlign: 'left',
									color: '#555B67',
									fontSize: '14px',
								}}
							>
								<th style={{ Width: '20%' }}>INVOICE NUMBER</th>
								<th style={{ Width: '20%' }}>INVOICE DATE</th>
								<th style={{ Width: '20%' }}>AMOUNT</th>
								<th style={{ Width: '20%' }}>BALANCE</th>
								<th style={{ Width: '20%' }}>CREDIT TO APPLY</th>
							</tr>
						</thead>

						<tbody
							style={{
								display: 'block',
								maxHeight: '200px',
								overflowY: 'auto',
								width: '100%',
							}}
						>
							{openInvoiceTable?.map((ele, index) => (
								<tr
									key={index}
									style={{
										display: 'table',
										tableLayout: 'fixed',
										height: '80px',
										width: '100%',
										backgroundColor: index === 1 ? '#f0f8ff' : 'transparent',
									}}
								>
									<td
										style={{
											border: '1px solid #dee2e6',
											textAlign: 'right',
										}}
									>
										{ele?.invoice_number}
									</td>

									<td
										style={{
											border: '1px solid #dee2e6',
											textAlign: 'right',
										}}
									>
										{getDate(ele?.date)}
									</td>
									<td
										style={{
											border: '1px solid #dee2e6',
											textAlign: 'right',
										}}
									>
										<b>Rs.</b>
										{ele?.total_amount}
									</td>
									<td
										style={{
											border: '1px solid #dee2e6',
											textAlign: 'right',
										}}
									>
										<b>Rs.</b>
										{ele?.balance_due_before}
									</td>
									<td
										style={{
											border: '1px solid #dee2e6',
											textAlign: 'right',
										}}
									>
										<div
											style={{
												marginTop: '4px',
												display: 'flex',
												justifyContent: 'flex-end',
												flexDirection: 'column',
												alignItems: 'end',
												width: '100%',
											}}
										>
											<input
												className="table_input"
												type={'number'}
												name={'Credit Amount'}
												value={ele?.applied_credit_amount}
												style={{
													border:
														errorCells.filter((data) => data.index === index && data.error !== '')
															.length > 0 &&
														errorCells
															.filter((data) => data.index === index && data.error !== '')
															.map((item) => item.error)
															? '1px solid red'
															: '1px solid rgba(85, 91, 103, 0.15)',
													borderRadius: '8px',
													height: '35px',
													width: '100%',
													textAlign: 'right',
												}}
												onChange={(e) => {
													const valueData = e.target.value;
													let value = valueData?.replace(/[+-]/g, '').replace(/[^0-9.]/g, '');
													handleCreditChange(index, value);
												}}
												onKeyDown={(e) => {
													handleKeyDown(index, e);
												}}
												ref={(el) => (inputRefs.current[index] = el)}
											/>

											<span style={{ color: 'red', fontSize: '14px' }}>
												{errorCells.filter((data) => data.index === index && data.error !== '')
													.length > 0 &&
													errorCells
														.filter((data) => data.index === index && data.error !== '')
														.map((item) => item.error)}
											</span>
										</div>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
				{errorCells.length > 0 && (
					<div
						style={{
							fontSize: '14px',
							fontWeight: 'bold',
							color: '#ff0000ff',
							marginRight: '10px',
							paddingBottom: '5px',
						}}
					>
						{'One or more rows have invalid payments. Please review before saving.'}
					</div>
				)}
				{error && (
					<div
						style={{
							fontSize: '14px',
							fontWeight: 'bold',
							color: '#ff0000ff',
							marginRight: '10px',
							paddingBottom: '5px',
						}}
					>
						{error}
					</div>
				)}
				<div
					style={{
						display: 'flex',
						justifyContent: 'flex-end',
					}}
				>
					<div
						className="totals"
						style={{
							fontSize: '14px',
							fontWeight: 'bold',
							color: '#000000',
							marginRight: '10px',
							textAlign: 'right',
						}}
					>
						<p>Credit Applied</p>
						<p>Remaining Credits</p>
					</div>
					<div style={{ color: '#555B67', textAlign: 'right' }}>
						<p style={{ fontSize: '14px' }}>
							<b>Rs.</b>
							{totalRemainingCredit().toFixed(2)}
						</p>
						<p style={{ fontSize: '14px' }}>
							<b>Rs.</b>
							{Number(
								Number(creditNoteDetails.total_credit_amount).toFixed(2) -
									Number(creditNoteDetails.total_paid_amount).toFixed(2) -
									totalRemainingCredit().toFixed(2),
							).toFixed(2)}
						</p>
					</div>
				</div>
			</div>
		</Modal>
	);
};

export default ApplyInvoice;
